import { apiCall, API, NEW_BE_API } from '../../utils/APIFunctions';

export function searchObjects(params, globalAbortController) {
  let url = `${API}/elasticsearch/objects/search?q=${params.q}&size=${params.size}&from=${params.from}`
  if (params.searchFolders !== undefined) {
    url += `&searchFolders=${params.searchFolders}`;
  }
  if (params.objectTypes && params.objectTypes.length > 0) {
    url += `&objectTypes=${params.objectTypes.join(',')}`;
  }
  return apiCall(url, "GET", null, globalAbortController.signal);
}

export function searchObjectsInFolder(params, globalAbortController) {
  let url = `${NEW_BE_API}/api/n1/elasticsearch/objects/folder-search?q=${encodeURIComponent(params.q)}&size=${params.size}&from=${params.from}&folderId=${params.folderId}`;
  if (params.objectTypes && params.objectTypes.length > 0) {
    url += `&objectTypes=${params.objectTypes.join(',')}`;
  }
  return apiCall(url, "GET", null, globalAbortController?.signal);
}